import script from "./Month.vue?vue&type=script&setup=true&lang=js"
export * from "./Month.vue?vue&type=script&setup=true&lang=js"

import "./Month.vue?vue&type=style&index=0&id=9e3464ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e3464ba"]])

export default __exports__